import {useStores} from '../../stores/useStores';

import { observer } from "mobx-react-lite";
import { useState } from 'react';
import CardStore from 'src/stores/CardStore';
import NumberFormat from 'react-number-format';
import TokenChooser from '../TokenChooser';
import { ASSET_ID, tokenInfo } from 'src/constants/common';

import {ReactComponent as MiniPuzzleIcon} from '../../assets/icons/miniPuzzleIcon.svg';
import {ReactComponent as UsdnIcon} from '../../assets/tokens/xtn.svg';
import {ReactComponent as EggIcon} from '../../assets/tokens/EGG.svg';
import {ReactComponent as UsdtIcon} from '../../assets/tokens/USDT.svg';
import {ReactComponent as UsdcIcon} from '../../assets/tokens/usdc.svg';
import {ReactComponent as WavesIcon} from '../../assets/tokens/waves-logo.svg';
import {ReactComponent as PeteIcon} from '../../assets/tokens/pete.svg';

import {ReactComponent as InfoIcon} from '../../assets/icons/info.svg';
import Switch from '../Switch';

interface IPriceBlockOptions {
    nftData: CardStore|null;
    cb?: Function;
}

export default observer(function(props: IPriceBlockOptions) {
    const { accountStore, notificationStore } = useStores();

    const [messageText, setMessageText] = useState<string>(`I want to buy your NFT. My telegram @...\nName: ${props.nftData?.name}\nId: ${props.nftData?.assetId}`);
    const [messageActivated, setMessageActivated] = useState<boolean>(false);
    const [isFree, setIsFree] = useState<boolean>(false);

    const [recipient, setRecipient] = useState<string>();
    const [sendMessageText, setSendMessageText] = useState<string>();
    const [sellerComment, setSellerComment] = useState<string>();
    const [sellActivated, setSellActivated] = useState<boolean>(false);
    const [sendActivated, setSendActivated] = useState<boolean>(false);

    const [selectedKey, setSelectedKey] = useState<any>(ASSET_ID.PUZZLE);

    let isUserOwner = false;
    if (props.nftData?.seller) {
        isUserOwner = accountStore.address === props.nftData.seller;
    }
    if (props.nftData?.owner) {
        isUserOwner = true;
    }

    let fee: number = 10;
    let feeUsdn: number = 0;
    let profit: number = 0;
    const groupRate = props.nftData?.isGroup ? props.nftData.groupAvailable : 1;
    if (props.nftData) {
        if (props.nftData.isDuck) {
            fee = 30;
        }
        const basePrice = ((props.nftData.value || 0) as number * accountStore.rootStore.usdtPrices[selectedKey]) * groupRate;
        feeUsdn = basePrice * (fee / 100);
        profit = basePrice - feeUsdn;
    }

    return (
        <div>
            {
                props.nftData && isUserOwner && !props.nftData?.isOnSell && sellActivated ?
                    <div className='nftMarketplace-card__inputBlock'>
                        <div className="nftMarketplace-card__switch">
                            <Switch
                                onChange={() => setIsFree(!isFree)}
                                value={isFree}
                            />&nbsp;&nbsp;
                            <label>{!isFree ? 'Not for': 'Is'} free</label>
                        </div>
                        {
                            !isFree ?
                                <div className='nftMarketplace-card__priceWrap'>
                                    <NumberFormat 
                                        className='nftMarketplace-card__input'
                                        displayType='input'
                                        value={props.nftData.value || ''}
                                        placeholder='Price'
                                        thousandSeparator={true}
                                        onValueChange={(values) => {
                                            const { value } = values;
                                            props.nftData?.valueChange(parseFloat(value))
                                        }}
                                    />
                                    <TokenChooser
                                        className='nftMarketplace-auction__select'
                                        selected={selectedKey}
                                        selectFn={(key: string) => {
                                            setSelectedKey(key);
                                        }} />
                                </div> : ''
                        }

                        {
                            !isFree ?
                                <div className='nftMarketplace-card__fee'>
                                    <InfoIcon className='nftMarketplace-card__feeIcon'/>
                                    <div>
                                        <div>
                                            fee <span className='nftMarketplace-card__feeValue'>{fee}</span>%:&nbsp;
                                            <NumberFormat
                                                className='nftMarketplace-card__feeValue'
                                                displayType='text'
                                                decimalScale={2}
                                                value={(props.nftData.value as number * groupRate) * (fee / 100)}
                                                thousandSeparator={true} />
                                            &nbsp;
                                            {tokenInfo[selectedKey].title}
                                            &nbsp;
                                            <NumberFormat
                                                className='nftMarketplace-card__feeValue'
                                                displayType='text'
                                                prefix='~ $'
                                                value={feeUsdn}
                                                decimalScale={2}
                                                title="USD"
                                                thousandSeparator={true} />
                                        </div>
                                        <div>
                                            you will get{props.nftData.isGroup ? ` for ${groupRate} pcs` : ''}:&nbsp;
                                            <NumberFormat
                                                className='nftMarketplace-card__feeValue'
                                                displayType='text'
                                                decimalScale={2}
                                                value={(props.nftData.value as number) - ((props.nftData.value as number) * (fee / 100))}
                                                thousandSeparator={true} />
                                            {
                                                props.nftData.isGroup ?
                                                    <span>
                                                        {` * ${groupRate} pcs = `}
                                                        <NumberFormat
                                                            className='nftMarketplace-card__feeValue'
                                                            displayType='text'
                                                            decimalScale={2}
                                                            value={(props.nftData.value as number * groupRate) - ((props.nftData.value as number * groupRate) * (fee / 100))}
                                                            thousandSeparator={true} />
                                                    </span> : ''
                                            }
                                            &nbsp;
                                            {tokenInfo[selectedKey].title}
                                            &nbsp;
                                            <NumberFormat
                                                className='nftMarketplace-card__feeValue'
                                                displayType='text'
                                                prefix='~ $'
                                                value={profit}
                                                decimalScale={2}
                                                title="USD"
                                                thousandSeparator={true} />
                                        </div>

                                    </div>
                                </div> : ''
                        }
                        <div>
                            <textarea
                                className='nftMarketplace-card__input nftMarketplace-card__messageInput_send'
                                maxLength={500}
                                rows={5}
                                value={sellerComment}
                                placeholder="Comment for buyers"
                                onChange={(e) => { setSellerComment(e.target.value) }}
                            ></textarea>
                        </div>
                    </div> : ''
            }
            {
                props.nftData && isUserOwner && !props.nftData?.isOnSell && sendActivated ?
                    <div className='nftMarketplace-card__inputBlock'>
                        <input
                            className='nftMarketplace-card__input'
                            type="text"
                            value={recipient}
                            onChange={(e) => { setRecipient(e.target.value) }}
                            required
                            placeholder='Recipient address' />
                        <textarea
                            className='nftMarketplace-card__input nftMarketplace-card__messageInput_send'
                            maxLength={140}
                            rows={5}
                            value={sendMessageText}
                            placeholder="Your message"
                            onChange={(e) => { setSendMessageText(e.target.value) }}
                        ></textarea>
                    </div> : ''
            }
            <div className='nftMarketplace-card__footer'>
                <div className='nftMarketplace-card__priceBlock'>
                    {
                        props.nftData?.isOnSell ?
                            <div className='nftMarketplace-card__price'>
                                <div className='nftMarketplace-card__priceWithToken'>
                                    {props.nftData.price}&nbsp;
                                    {props.nftData.buyOutAssetId === ASSET_ID.PUZZLE ?
                                        <MiniPuzzleIcon style={{width: '20px', height: '20px'}} title="Puzzle"/> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.USDN ?
                                        <UsdnIcon style={{width: '24px', height: '20px'}} title="XTN"/> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.PETE ?
                                        <PeteIcon style={{width: '24px', height: '20px'}} title="PETE"/> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.WAVES ?
                                        <WavesIcon style={{width: '18px', height: '18px'}} title="Waves"/> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.EGG ?
                                        <EggIcon style={{width: '24px', height: '24px'}} title="Egg"/> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.USDT ?
                                        <UsdtIcon style={{width: '24px', height: '24px'}} title="USDT PPT"/> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.USDC ?
                                        <UsdcIcon style={{width: '24px', height: '24px'}} title="USDC PPT"/> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.USDT_WX ?
                                        <>
                                            <UsdtIcon style={{width: '24px', height: '24px'}} title="USDT WX"/>
                                            <div className="wx_label">wx</div>
                                        </> : ''}
                                    {props.nftData.buyOutAssetId === ASSET_ID.USDC_WX ?
                                        <>
                                            <UsdcIcon style={{width: '24px', height: '24px'}} title="USDC WX"/>
                                            <div className="wx_label">wx</div>
                                        </> : ''}
                                </div>
                                {
                                    accountStore.rootStore.usdtPrices[props.nftData.buyOutAssetId] ?
                                    <NumberFormat
                                        className='nftMarketplace-card__priceUsdn'
                                        displayType='text'
                                        prefix='~ $'
                                        title='USDT'
                                        value={(props.nftData.usdtPrice).toFixed(2)}
                                        thousandSeparator={true} /> : ''
                                }
                            </div> : ''
                    }
                    {
                        props.nftData && isUserOwner && !props.nftData.isOnSell && !sendActivated ?
                            <button className='nftMarketplace-card__button' onClick={() => {
                                if (!sellActivated) setSellActivated(true);
                                else {
                                    props.nftData?.sell(() => props.cb?.(), isFree ? 'free' : selectedKey, sellerComment)
                                }
                            }}>Sell</button> :
                            ''
                    }
                    {
                        props.nftData && isUserOwner && !props.nftData.isOnSell && !sellActivated ?
                            <button className={'nftMarketplace-card__button' + (!sendActivated ? ' nftMarketplace-card__button_white' : '')} onClick={() => {
                                if (!sendActivated) setSendActivated(true);
                                else {
                                    props.nftData?.send({
                                        recipient: recipient || '',
                                        message: sendMessageText,
                                        amount: 1,
                                        assetId: props.nftData.assetId
                                    }, () => {
                                        props.cb?.();
                                        setRecipient('');
                                        setSendMessageText('');
                                    })
                                }
                            }}>Send</button> :
                            ''
                    }
                    {
                        props.nftData && isUserOwner && !props.nftData.isOnSell && (sellActivated || sendActivated) ?
                            <button className='nftMarketplace-card__button nftMarketplace-card__button_white' onClick={() => {
                                setSellActivated(false);
                                setSendActivated(false);
                            }}>Cancel</button> :
                            ''
                    }
                    {
                        !isUserOwner && props.nftData?.isOnSell ?
                            <button className='nftMarketplace-card__button' onClick={() => props.nftData?.buy(() => props.cb?.())}>{props.nftData.isFree ? 'Take it' : 'Buy now'}</button> : ''
                    }
                    {
                        isUserOwner && props.nftData?.isOnSell ?
                            <button className='nftMarketplace-card__button nftMarketplace-card__button_white' onClick={() => props.nftData?.cancel(() => props.cb?.())}>Cancel</button> : ''
                    }
                    {
                        props.nftData?.isGroup ? <div className='nftMarketplace-card__groupSize'>{props.nftData.groupAvailable} of {props.nftData.groupSize} available</div> : ''
                    }
                </div>
                
                <div className='nftMarketplace-card__messageBlock'>
                    {
                        !isUserOwner && props.nftData?.seller && messageActivated ?
                            <textarea
                                className='nftMarketplace-card__input nftMarketplace-card__messageInput'
                                maxLength={140}
                                rows={5}
                                value={messageText}
                                onChange={(e) => {setMessageText(e.target.value)}}
                            ></textarea> :
                            ''
                    }
                    <div style={{display: 'flex'}}>
                        {
                            !isUserOwner && props.nftData?.seller ? <button
                                disabled={!messageText}
                                className={
                                    'nftMarketplace-card__button nftMarketplace-card__sendMessageButton' +
                                        (!messageActivated ? ' nftMarketplace-card__button nftMarketplace-card__button_white' : '') +
                                        (messageActivated && !messageText ? ' nftMarketplace-card__button_disabled' : '')
                                }
                                onClick={() => {
                                    if (!messageActivated) {
                                        setMessageActivated(true);
                                    } else if (messageText) {
                                        accountStore.transfer({
                                            recipient: props.nftData?.seller || '',
                                            attachment: messageText
                                        }).then((txId) => {
                                            if (txId) {
                                                notificationStore.notify(`Message sent`, {
                                                    type: "success",
                                                    title: `Success`,
                                                    link: `https://wavesexplorer.com/tx/${txId}`,
                                                    linkTitle: "View on Explorer",
                                                });
                                            }
                                        }).catch((e) => {
                                            notificationStore.notify(e.message ?? JSON.stringify(e), {
                                                type: "error",
                                                title: "Transaction is not completed",
                                            });
                                        });
                                    }
                                }}>
                                { messageActivated ? 'Send' : 'Send message to seller' }
                            </button> : ''

                        }
                        {
                            !isUserOwner && props.nftData?.seller && messageActivated ? <button
                                className='nftMarketplace-card__button nftMarketplace-card__button_white'
                                style={{marginRight: 0}}
                                onClick={() => { setMessageActivated(false) }}>
                                Cancel
                            </button> : ''
                    }
                    </div>
                </div>
            </div>
        </div>
    );
});
